import { serviceURL } from "../../utils/service-url";
import type { UUID } from "../../utils/uuid";

export class MediaService {
  constructLandingPageURL(id: UUID): string {
    return `${serviceURL("media")}v/${id}`;
  }
}
